import { TeamStats } from '@/components/team-details/types';

export const calculateMatchStats = (matches: any[], teamName: string): TeamStats => {
  const stats: TeamStats = {
    played: 0,
    homeMatches: 0,
    awayMatches: 0,
    wins: 0,
    draws: 0,
    losses: 0,
    goalsFor: 0,
    goalsAgainst: 0,
    totalShots: { home: 0, away: 0 },
    shotsOnTarget: { home: 0, away: 0 },
    corners: { home: 0, away: 0 },
    fouls: { home: 0, away: 0 },
    yellowCards: { home: 0, away: 0 },
    redCards: { home: 0, away: 0 },
    homeOnlyStats: {
      shots: 0,
      shotsOnTarget: 0,
    },
    awayOnlyStats: {
      shots: 0,
      shotsOnTarget: 0,
    },
    fullTimeStats: {
      homeGoals: 0,
      awayGoals: 0,
      homeGoalsConceded: 0,
      awayGoalsConceded: 0,
      homeWins: 0,
      awayWins: 0,
      homeDraws: 0,
      awayDraws: 0,
      homeLosses: 0,
      awayLosses: 0,
      homeCleanSheets: 0,
      awayCleanSheets: 0,
      homeBTTS: 0,
      awayBTTS: 0,
    },
    halfTimeStats: {
      homeGoals: 0,
      awayGoals: 0,
      homeGoalsConceded: 0,
      awayGoalsConceded: 0,
      homeWins: 0,
      awayWins: 0,
      homeDraws: 0,
      awayDraws: 0,
      homeLosses: 0,
      awayLosses: 0,
      homeBTTS: 0,
      awayBTTS: 0,
    }
  };

  matches.forEach(match => {
    const isHomeMatch = match.HomeTeam === teamName;
    const isAwayMatch = match.AwayTeam === teamName;

    if (isHomeMatch) {
      stats.homeMatches++;
      stats.played++;
      
      // Full time stats
      const homeGoals = parseInt(match.FTHG) || 0;
      const awayGoals = parseInt(match.FTAG) || 0;
      stats.goalsFor += homeGoals;
      stats.goalsAgainst += awayGoals;
      stats.fullTimeStats.homeGoals += homeGoals;
      stats.fullTimeStats.homeGoalsConceded += awayGoals;

      // BTTS calculation for home games
      if (homeGoals > 0 && awayGoals > 0) {
        stats.fullTimeStats.homeBTTS++;
      }

      // Clean sheet calculation for home games
      if (awayGoals === 0) {
        stats.fullTimeStats.homeCleanSheets++;
      }

      if (homeGoals > awayGoals) {
        stats.wins++;
        stats.fullTimeStats.homeWins++;
      } else if (homeGoals < awayGoals) {
        stats.losses++;
        stats.fullTimeStats.homeLosses++;
      } else {
        stats.draws++;
        stats.fullTimeStats.homeDraws++;
      }

      // Half time stats
      const halfTimeHomeGoals = parseInt(match.HTHG) || 0;
      const halfTimeAwayGoals = parseInt(match.HTAG) || 0;
      stats.halfTimeStats.homeGoals += halfTimeHomeGoals;
      stats.halfTimeStats.homeGoalsConceded += halfTimeAwayGoals;

      // Half time BTTS calculation for home games
      if (halfTimeHomeGoals > 0 && halfTimeAwayGoals > 0) {
        stats.halfTimeStats.homeBTTS++;
      }

      if (match.HTR === 'H') stats.halfTimeStats.homeWins++;
      else if (match.HTR === 'A') stats.halfTimeStats.homeLosses++;
      else if (match.HTR === 'D') stats.halfTimeStats.homeDraws++;

      // Other stats
      stats.homeOnlyStats.shots += parseInt(match.HS) || 0;
      stats.homeOnlyStats.shotsOnTarget += parseInt(match.HST) || 0;
      stats.totalShots.home += parseInt(match.HS) || 0;
      stats.shotsOnTarget.home += parseInt(match.HST) || 0;
      stats.corners.home += parseInt(match.HC) || 0;
      stats.fouls.home += parseInt(match.HF) || 0;
      stats.yellowCards.home += parseInt(match.HY) || 0;
      stats.redCards.home += parseInt(match.HR) || 0;

    } else if (isAwayMatch) {
      stats.awayMatches++;
      stats.played++;
      
      // Full time stats
      const homeGoals = parseInt(match.FTHG) || 0;
      const awayGoals = parseInt(match.FTAG) || 0;
      stats.goalsFor += awayGoals;
      stats.goalsAgainst += homeGoals;
      stats.fullTimeStats.awayGoals += awayGoals;
      stats.fullTimeStats.awayGoalsConceded += homeGoals;

      // BTTS calculation for away games
      if (homeGoals > 0 && awayGoals > 0) {
        stats.fullTimeStats.awayBTTS++;
      }

      // Clean sheet calculation for away games
      if (homeGoals === 0) {
        stats.fullTimeStats.awayCleanSheets++;
      }

      if (awayGoals > homeGoals) {
        stats.wins++;
        stats.fullTimeStats.awayWins++;
      } else if (awayGoals < homeGoals) {
        stats.losses++;
        stats.fullTimeStats.awayLosses++;
      } else {
        stats.draws++;
        stats.fullTimeStats.awayDraws++;
      }

      // Half time stats
      const halfTimeHomeGoals = parseInt(match.HTHG) || 0;
      const halfTimeAwayGoals = parseInt(match.HTAG) || 0;
      stats.halfTimeStats.awayGoals += halfTimeAwayGoals;
      stats.halfTimeStats.awayGoalsConceded += halfTimeHomeGoals;

      // Half time BTTS calculation for away games
      if (halfTimeHomeGoals > 0 && halfTimeAwayGoals > 0) {
        stats.halfTimeStats.awayBTTS++;
      }

      if (match.HTR === 'A') stats.halfTimeStats.awayWins++;
      else if (match.HTR === 'H') stats.halfTimeStats.awayLosses++;
      else if (match.HTR === 'D') stats.halfTimeStats.awayDraws++;

      // Other stats
      stats.awayOnlyStats.shots += parseInt(match.AS) || 0;
      stats.awayOnlyStats.shotsOnTarget += parseInt(match.AST) || 0;
      stats.totalShots.away += parseInt(match.AS) || 0;
      stats.shotsOnTarget.away += parseInt(match.AST) || 0;
      stats.corners.away += parseInt(match.AC) || 0;
      stats.fouls.away += parseInt(match.AF) || 0;
      stats.yellowCards.away += parseInt(match.AY) || 0;
      stats.redCards.away += parseInt(match.AR) || 0;
    }
  });

  return stats;
};
